<h5>Solicitação de Arquivos</h5>

<div class="container">
  <div class="row">
    <div class="col">
      <h3>Filtros de Pesquisa</h3>
    </div>

    <div class="col-auto">
      <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
    </div>

    <div class="col-auto">
      <button #focusableSubmit type="button" class="btn btn-success no-margin" (click)="buscar()">
        Pesquisar
      </button>
    </div>
  </div>

  <div class="row">

    <div class="bn-form-group col-md-5">
        <label>CNPJ Agente Financeiro:</label>
        <input class="form-control" name="cnpj" [(ngModel)]="cnpjAgenteFinanceiro" bnMask="cnpj">
    </div>

    <div class="bn-form-group col-md-5">
        <label>Tipo da Solicitação:</label>
        <select id="irregularidade-empresa" class="form-select" [(ngModel)]="codigoTipoSolicitacao">
          <option [ngValue]="undefined" selected>Todas</option>
          <option *ngFor="let item of tipoSolicitacao" [ngValue]="item.codigo">
            {{(item.nome)}}
          </option>
      </select>
    </div>

    <div class="bn-form-group col-md-5">
        <label>Data Inicial da Solicitação</label>
        <bn-datepicker
            name="dataInicio"
            idInput="dataInicio"
            ngDefaultControl
            [(ngModel)]="dataInicio">
        </bn-datepicker>
    </div>

    <div class="bn-form-group col-md-5">
        <label>Data Final da Solicitação</label>
        <bn-datepicker
            name="dataFim"
            idInput="dataFim"
            ngDefaultControl
            [(ngModel)]="dataFim">
        </bn-datepicker>
    </div>
  </div>
</div>

<app-solicitacao-arquivos-listagem
  [arquivo]="arquivo"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  [formatoArquivo]="formatoArquivo"
  *ngIf="pesquisado">
</app-solicitacao-arquivos-listagem>
